/**
 * Le Vanilla default layout — the shape every linked event renders from.
 *
 * Forking copies this object into events.layout. The Director then mutates
 * that copy. Improvements to this constant flow to every linked event
 * automatically on next page load.
 */

import type { Layout } from '../../layout'

export const LE_VANILLA_DEFAULT_LAYOUT: Layout = {
  version: 1,
  shell: 'le_vanilla',
  slots: {
    topbar: [{ id: 'topbar', primitive: 'Topbar', config: {} }],
    player: [{ id: 'player', primitive: 'PrimaryView', config: {} }],
    player_overlay: [
      { id: 'player-clean-view', primitive: 'CleanViewButton', config: {} },
      { id: 'player-fullscreen', primitive: 'FullscreenButton', config: {} },
    ],
    below_player: [
      { id: 'title', primitive: 'EventTitle', config: {} },
      { id: 'producer', primitive: 'ProducerRow', config: { showFollow: true } },
      { id: 'engagement', primitive: 'EngagementCluster', config: {} },
      { id: 'description', primitive: 'EventDescription', config: {} },
    ],
    sidebar: [
      { id: 'rail', primitive: 'CameraRail', config: { sortBy: 'position' } },
      { id: 'sponsor', primitive: 'SponsorLockup', config: {} },
      { id: 'leaders', primitive: 'ResultsView', config: {} },
    ],
    mobile_switcher: [
      {
        id: 'mms',
        primitive: 'ViewSwitcher',
        config: { modes: ['about', 'cameras'], defaultMode: 'about' },
      },
    ],
  },
}
